<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-title>Carter Admin Dashboard</ion-title>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="dashboard-screen">
         <CarterDashboard />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import CarterDashboard from "@/components/carter/carterDashboard.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'carterAdminDashboard',
    components: {
        CarterDashboard, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent
    },
    data() {
        return {

        }
    },
})
</script>
<style scoped>

.dashboard-screen {
    overflow: auto !important;
    position: relative;
}
</style>